import { IconButton } from "@xapp/chat-widget-core";
import React, { FC, MouseEvent } from "react";
import { SendIcon } from "../Icons";
import "./SendButton.scss";

export interface Props {
    className?: string;
    sendButtonIcon?: string;
    sendButtonIconHover?: string; // Icon URL for hover state
    sendButtonIconDisabled?: string; // Icon URL for disabled state
    tabIndex?: string;
    disabled?: boolean;
    onClick(e: MouseEvent): void;
}

const SendButton: FC<Props> = (props) => {
    const { disabled = false } = props;
    const [isHovered, setIsHovered] = React.useState(false);

    // Determine which icon to show based on state
    const getIconSrc = () => {
        if (disabled && props.sendButtonIconDisabled) {
            return props.sendButtonIconDisabled;
        }
        if (isHovered && !disabled && props.sendButtonIconHover) {
            return props.sendButtonIconHover;
        }
        return props.sendButtonIcon;
    };

    return (
        <>
            {!props.sendButtonIcon ? (
                <IconButton
                    className={`xappw-send-button ${props.className || ""} ${disabled ? 'disabled' : ''}`}
                    tabIndex={props.tabIndex}
                    onClick={disabled ? undefined : props.onClick}
                    icon={SendIcon}
                />
            ) : (
                <button
                    className={`xappw-custom-send-button ${disabled ? 'disabled' : ''}`}
                    tabIndex={props.tabIndex ? Number(props.tabIndex) : 0}
                    onClick={props.onClick}
                    disabled={disabled}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <img
                        src={getIconSrc()}
                        alt="Send button"
                        draggable={false}
                        className="send-button-icon"
                    />
                </button>
            )}
        </>
    );
};

export default SendButton;
